import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function BackIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "primary";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          color={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="Back">
          <path
              d="M9.03 13.209h9.637c.733 0 1.333-.546 1.333-1.214 0-.667-.6-1.214-1.333-1.214H9.03V8.61c0-.546-.72-.813-1.133-.425L4.19 11.57a.584.584 0 0 0 0 .862l3.707 3.387c.413.388 1.133.109 1.133-.425v-2.185Z"
          />
      </SvgIcon>
  );
}
